/**
 * A basic bot detection utility.
 *
 * @returns {Boolean}
 */
export const isBot = /bot|crawl|spider/i.test(navigator.userAgent);
